import { useNavigate } from "react-router-dom";
import {
  Button,
  Cell,
  List,
  Placeholder,
  Section,
  Spinner,
} from "@telegram-apps/telegram-ui";

import { useAppData } from "../AppData";
import { useAuth } from "../AuthProvider";

function fullName(
  first?: string | null,
  last?: string | null,
  username?: string | null,
): string {
  const name = [first, last].filter(Boolean).join(" ").trim();
  if (name) return name;
  if (username) return `@${username}`;
  return "Пользователь";
}

export function SettingsPage() {
  const navigate = useNavigate();
  const { me, loading, error } = useAppData();
  const { mode, logout } = useAuth();

  if (loading) {
    return (
      <div style={{ padding: 32, textAlign: "center" }}>
        <Spinner size="m" />
      </div>
    );
  }

  if (error || !me) {
    return <Placeholder header="Ошибка" description={error ?? "Нет данных"} />;
  }

  return (
    <div className="page page--with-nav">
      <List>
        <Section header="Профиль">
          <Cell
            subtitle={me.username ? `@${me.username}` : `ID ${me.tgid}`}
            after={
              <span className={`role-badge role-badge--${me.role}`}>
                {me.role === "admin" ? "Администратор" : "Пользователь"}
              </span>
            }
          >
            {fullName(me.first_name, me.last_name, me.username)}
          </Cell>
        </Section>

        {me.is_admin && (
          <Section header="Администрирование">
            <Cell
              subtitle="Роли и доступ к функциям"
              onClick={() => navigate("/settings/users")}
              style={{ cursor: "pointer" }}
            >
              Пользователи
            </Cell>
            <Cell
              subtitle="Управление контрагентами"
              onClick={() => navigate("/settings/data")}
              style={{ cursor: "pointer" }}
            >
              Контрагенты
            </Cell>
            <Cell
              subtitle="Управление договорами"
              onClick={() => navigate("/settings/contracts")}
              style={{ cursor: "pointer" }}
            >
              Договоры
            </Cell>
          </Section>
        )}

        {mode === "web" && (
          <div style={{ padding: "16px" }}>
            <Button size="l" stretched mode="bezeled" onClick={logout}>
              Выйти
            </Button>
          </div>
        )}
      </List>
    </div>
  );
}
